<div class="row d-flex justify-content-between my-3">
  <div class="col-12 col-md-4 order-2 order-md-1">
    <div class="table-search">
      <input
        #searchText
        type="search"
        class="form-control"
        placeholder="Search ProForms"
        aria-label="Search ProForms"
        (input)="searchTermChanged($event)" />
    </div>
  </div>
</div>
<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="table-wrapper w-100 mt-3">
    <table
      *ngIf="forms && forms.length > 0; else noResults"
      class="table gl-striped-table my-4">
      <!--TABLE HEADER-->
      <thead>
        <tr class="align-middle">
          <th scope="col">Title</th>
          <th class="no-wrap" scope="col">Owner</th>
          <th class="no-wrap" scope="col">Type</th>
          <th class="no-wrap" scope="col">Shared</th>
          <th class="np-wrap" scope="col"></th>
        </tr>
      </thead>
      <!--TABLE BODY-->
      <tbody>
        <tr *ngFor="let form of forms" class="align-top">
          <td>
            <span class="fw-600 color-primary">{{ form.title }}</span>
          </td>
          <td>
            {{ form.district?.title }}
          </td>
          <td>
            {{ form.type }}
          </td>
          <td class="submission-col">
            @if ( form.is_shared && (form.districtsSharedWith &&
            form.districtsSharedWith.length < 1) && (form.districtsExcludedFrom
            && form.districtsExcludedFrom.length < 1 )) {
            <i class="bi bi-check-circle-fill text-success"></i>} @if (
            !form.is_shared) { <i class="bi bi-dash-circle text-danger"></i>}
            @if(form.districtsSharedWith && form.districtsSharedWith.length > 0)
            {

            <div class="fw-700 fs-13 mb-1 text-success">Shared with:</div>
            <ul>
              @for(district of form.districtsSharedWith; track district.id) {
              <li class="fs-12">{{ district.district.title }}</li>
              }
            </ul>
            } @if(form.districtsExcludedFrom &&
            form.districtsExcludedFrom.length > 0) {

            <div class="fw-700 fs-13 mb-1 text-danger">Excluded from:</div>
            <ul>
              @for(district of form.districtsExcludedFrom; track district.id) {
              <li class="fs-12">{{ district.district.title }}</li>
              }
            </ul>
            }
          </td>
          <td class="edit-col">
            <button
              ngbTooltip="Preview"
              (click)="previewForm(form.id)"
              class="btn btn-link color-tertiary p-1">
              <i class="bi bi-eye p-1"></i>
            </button>
            <app-proform-preview-modal #previewModal [formId]="form.id" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <section>
    <div class="d-flex justify-content-center">
      <ngb-pagination
        *ngIf="pagination && pagination.totalCount > 10"
        [(page)]="pagination.currentPage"
        [pageSize]="pagination.perPage"
        [collectionSize]="pagination.totalCount"
        [maxSize]="5"
        (pageChange)="pageChange($event)"></ngb-pagination>
    </div>
  </section>
  <ng-template #noResults>
    <div
      class="w-100 p-5 text-center d-flex justify-content-center align-items-center"
      style="min-height: 300px">
      <p>No templates created yet</p>
    </div>
  </ng-template>
</ng-container>
<ng-template #loadingTemplate>
  <div style="clear: both; height: 300px"></div>
  <app-loader [top]="200" />
</ng-template>
